import { render } from "./AddRecommendation.vue?vue&type=template&id=94e514a8&scoped=true"
import script from "./AddRecommendation.vue?vue&type=script&lang=js"
export * from "./AddRecommendation.vue?vue&type=script&lang=js"

import "./AddRecommendation.vue?vue&type=style&index=0&id=94e514a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94e514a8"]])

export default __exports__